// extracted by mini-css-extract-plugin
module.exports = {"adminDashboard":"AdminDashboard_adminDashboard__3-cgB"};